





















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import MoviesList from './shared/MoviesList/MoviesList.vue';
import ServiceAgent from '../services/serviceAgent';
import Movie from '../objects/movie';
import MovieRate from '../enums/movieRate';
import MovieType from '@/enums/movieType';
import EventBus from '@/services/eventBus';

const serviceAgent = new ServiceAgent();

@Component({
    components: {
        MoviesList,
    },
})
export default class MyMovies extends Vue {
    isWatchlist = true;

    MovieRate = MovieRate;

    filterOpened = false;

    moviesOnlyFilter = false;

    tvOnlyFilter = false;

    likedOnly = false;

    notLikedOnly = false;

    get viewedMovies() {
        let result = this.userMovies
            .filter((movie: Movie) => movie.MovieRate !== MovieRate.addedToWatchlist);

        if (this.moviesOnlyFilter && !this.tvOnlyFilter) {
            result = result.filter((m: Movie) => m.MovieType === MovieType.movie);
        } else if (!this.moviesOnlyFilter && this.tvOnlyFilter) {
            result = result.filter((m: Movie) => m.MovieType === MovieType.tv);
        }

        if (this.likedOnly && !this.notLikedOnly) {
            result = result.filter((m: Movie) => m.MovieRate === MovieRate.liked);
        } else if (!this.likedOnly && this.notLikedOnly) {
            result = result.filter((m: Movie) => m.MovieRate === MovieRate.notLiked);
        }

        return result;
    }

    get watchlistMovies() {
        let result = this.userMovies
            .filter((dto: Movie) => dto.MovieRate === MovieRate.addedToWatchlist);

        if (this.moviesOnlyFilter && !this.tvOnlyFilter) {
            result = result.filter((m: Movie) => m.MovieType === MovieType.movie);
        } else if (!this.moviesOnlyFilter && this.tvOnlyFilter) {
            result = result.filter((m: Movie) => m.MovieType === MovieType.tv);
        }

        return result;
    }

    get userId() {
        const result = this.$store.getters.userId;

        return result;
    }

    get userMovies() {
        const result = this.$store.getters.userMovies;

        return result;
    }

    @Watch('isWatchlist')
    onIsWatchlistChanged() {
        const self = this;
        EventBus.$emit('showLoader', true);

        setTimeout(() => {
            EventBus.$emit('showLoader', false);
        }, 500);
    }

    async mounted() {
        EventBus.$emit('setMoviesLoading', true);

        this.$store.dispatch('setUserMovies');
    }
}
